<template>
  <f7-page name="home" class="navbar-through toolbar-fixed">
    <f7-navbar title="MS Self-assessment" class="text-center"></f7-navbar>

    <f7-navbar>
      <f7-nav-title class="navbar-center-title">
        <img src="/static/logo.png" srcset="/static/logo-hq.png 2x" class="title-logo" alt=""/>
        <span class="title-text">Nevro vprašalniki</span>
      </f7-nav-title>
    </f7-navbar>

    <f7-block-title>
      Izberite vprašalnik
    </f7-block-title>
    <f7-list>
      <f7-list-item v-for="pro in pros"
                    :key="pro.id"
                    :link="'/info/' + pro.id + '/'"
                    :title="pro.name"></f7-list-item>
    </f7-list>

    <div class="row terms-of-use" @click="$refs.modalSheet.open(true)">Pogoji uporabe</div>

    <f7-sheet ref="modalSheet">
      <div class="toolbar">
        <div class="toolbar-inner">
          <div class="left">&nbsp;&nbsp;Pogoji uporabe</div>
          <div class="right">
            <a class="link sheet-close">Close</a>
          </div>
        </div>
      </div>
      <div class="sheet-modal-inner">
        <div class="page-content">
          <div class="block">
            <p style="text-align: justify">
              Ta spletna aplikacija je namenjena raziskavam. Podatki o bolniku, odgovori in rezultati vprašalnikov
              se ne shranjujejo niti ne posredujejo tretji osebi. Avtorji ne prevzemajo odgovornosti za nadaljno rabo
              rezultatov. Pred uporabo aplikacije se posvetujte z vašim zdravnikom.
            </p>
          </div>
        </div>
      </div>
    </f7-sheet>
  </f7-page>
</template>

<script>
import {pros} from '../assets/pros/pros'

export default {
  name: 'Home',
  data () {
    return {
      pros: pros
    }
  }
}
</script>

<style lang="scss" scoped>

  div[data-name="home"] /deep/ {

    .navbar-center-title {
      display: flex;
      flex-grow: 100;
      justify-content: center;
    }

    .title-text {
      padding-left: 10px;
      font-size: 24px;
      padding-top: 2px;
      line-height: 27px;
      text-transform: uppercase;
    }

    .terms-of-use {
      margin-top: 80px;
      width: 100%;
      text-align: center;
      color: #888;
      text-decoration: underline;
      cursor: pointer;
      justify-content: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue